import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
    selector: 'tt-category-datas',
    templateUrl: './category-datas.component.html',
    styleUrls: ['./category-datas.component.css'],
    standalone: false
})
export class CategoryDatasComponent implements OnInit {
    argType;

    argValue;

    public selectedBgCategoryDataSelection: string = 'A';

    public setting?: Setting;

    public selectListMainCategories: Item[] = [];

    public inputListCategoryDatas: CategoryDataItem[] = [];

    public saving = false;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.argType = this.stateService.getStateParams()['argtype'];
        this.argValue = this.stateService.getStateParams()['argvalue'];
    }

    private async loadSetting() {
        if (!!this.argType && !!this.argValue) {
            this.setting = (await this.datatask.Post(636, {
                argtype: this.argType,
                argvalue: this.argValue
            }))[0];
        }
    }

    private async loadMainCategories() {
        if (!!this.setting?.category_keyno_top && !!this.argType && !!this.argValue) {
            return this.selectListMainCategories = await this.datatask.Post(626, {
                category_keyno_top: this.setting.category_keyno_top,
                argtype: this.argType,
                argvalue: this.argValue
            });
        }
    }

    private async loadCategoryDatas() {
        if (!!this.setting?.category_keyno_top && !!this.argType && !!this.argValue) {
            const list = await this.datatask.Post(346, {
                argtype: this.argType,
                argvalue: this.argValue,
                category_keyno_top: this.setting.category_keyno_top
            });

            this.inputListCategoryDatas = list;
        }
    }

    public async saveChanges() {
        if (!!this.argType && this.argValue) {
            try {
                this.saving = true;

                const selectedItems = (this.inputListCategoryDatas ?? [])
                    .filter((row) => row['selected'] === '1')
                    .map((row) => ({
                        categorylink_keyno: row['categorylink_keyno'],
                        category_keyno: row['category_keyno'],
                        category_name: row['category_name'],
                        selected: row['selected'],
                        rectype: row['rectype']
                }));

                const mergeObj = {
                    argtype: this.argType,
                    argvalue: this.argValue,
                	records: selectedItems
                }

                await this.datatask.Post(356, mergeObj);

                this.stateService.back();
            } finally {
                this.saving = false;
            }
        }
    }

    public onChanged(_: string, id: keyof Setting) {
        if (!this.setting) return;

        switch (id) {
            case 'category_keyno_top':
                this.loadCategoryDatas();
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadMainCategories();
        this.loadCategoryDatas();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    category_keyno_top: string;
}

interface CategoryDataItem {
    categorylink_keyno: string;
    category_keyno: string;
    category_keyno_belongto: string;
    category_name: string;
    selected: string;
    rectype: string;
    levelno: string;
    orderby: string;
    visible: string;
}
